// IIFE to load the library
const AddInBulk = (() => {
  return {
    loadFile: (filePath) => {
      // Create a <script> tag, set its source
      let scriptTag = document.createElement("script");

      // Set the type of file and where it can be found
      scriptTag.type = "text/javascript";
      scriptTag.src = filePath;

      // Finally add it to the <head>
      document.getElementsByTagName("head")[0].appendChild(scriptTag);
    },
    init: () => {
      // Let's wait for Alpine to be loaded
      document.addEventListener("alpine:init", () => {
        console.log("Alpine Init");
                Alpine.store("addInBulk", {
          pending: {},
          open: false,
          text: "",
          buttonText: "",
          add(variantId, quantity, price) {
            const result = (this.pending[variantId]?.quantity ?? 0) + quantity
            this.pending = {
              ...this.pending,
              [variantId]: {
                quantity: result,
                price,
                total: result * price 
              }
            };
            this.updated();
          },
          subtract(variantId, quantity) {
            if (!this.pending[variantId] || this.pending[variantId].quantity === 0) {
              // noop
              return;
            }
            const result = this.pending[variantId].quantity - quantity
            this.pending = {
              ...this.pending,
              [variantId]: {
                ...this.pending[variantId],
                quantity: result,
                total: result * this.pending[variantId].price
              },
            };
            this.updated();
          },
          updated() {
            const quantity = Object.values(this.pending).reduce(
              (acc, val) => acc + val.quantity,
              0
            );
            const total = Object.values(this.pending).reduce(
              (acc, val) => acc + val.total,
              0
            );
            this.open = quantity > 0;
            this.text = `You have selected a total of ${quantity} product variants.`;
            this.buttonText = `ADD ALL TO CART - $ ${(total / 100).toFixed(2)}`
            

          },
          addToCart() {
            const items = Object.entries(this.pending).reduce((acc, val) => {
              return acc.concat({ id: +val[0], quantity: val[1].quantity });
            }, []);

            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({items})
            }).then(response => response.json()).then((data) => {
              theme.cart.getCart()
                .then((cart) => {
                  console.log("cart updated", cart);
                  document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart }})); 
                })
                .catch(() => {})
            }).catch(() => console.log("Failed to add")).finally(() => {
              document.dispatchEvent(new CustomEvent('cart:build'));
              document.dispatchEvent(new CustomEvent('cart:open'));
            })
            this.pending = {};
            this.updated();
          },
          addVariantToCart(id, element) {
            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({items: [{id, quantity: this.pending[id]?.quantity ?? 1}]})
            }).then(response => response.json()).then((data) => {
              this.pending = Object.keys(this.pending).reduce((acc, val) => {
                if (val == id) {
                  return acc;
                } else {
                  acc[val] = this.pending[val];
                  return acc;
                }
              }, {});
              this.updated();
              element.parentElement.classList.add('success');
              const bag = document.querySelector('.site-nav__link.site-nav__link--icon.js-drawer-open-cart');
              const rect = bag.getBoundingClientRect();
              
              // Calculate origin as a fraction of the viewport
              const x = rect.right / window.innerWidth;
              const y = rect.top / window.innerHeight;
              console.log({x, y})

              confetti({
                particleCount: 100,
                spread: 70,
                origin: { x, y },
              });
              setTimeout(() => {
                element.parentElement.classList.remove('success');
              }, 350);
              theme.cart.getCart()
                .then((cart) => {
                  console.log("cart updated", cart);
                  document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart }})); 
                })
                .catch(() => {})
            }).catch(() => console.log("Failed to add")).finally(() => {
              document.dispatchEvent(new CustomEvent('cart:build'));
              // document.dispatchEvent(new CustomEvent('cart:open'));
            })
          }
        });
      });
    },
  };
})();

document.addEventListener("DOMContentLoaded", () => {
  AddInBulk.init();
  // Check if Alpine is loaded otherwise load Alpine
  if (typeof Alpine === "undefined") {
    AddInBulk.loadFile("https://unpkg.com/alpinejs@3.x.x/dist/cdn.min.js");
  }
});
